import { render, staticRenderFns } from "./FieldViewCard.vue?vue&type=template&id=077c988a&scoped=true&"
import script from "./FieldViewCard.vue?vue&type=script&lang=js&"
export * from "./FieldViewCard.vue?vue&type=script&lang=js&"
import style0 from "./FieldViewCard.vue?vue&type=style&index=0&id=077c988a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c988a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
